import React from 'react';
import PropTypes from 'prop-types';
import { CODE_CATEGORIES } from '../../constants/api';
import { useApiAutocomplete } from '../../hooks/useApiAutocomplete';
import { application } from '../../services/application';
import { formatToTitleCase } from '../../utils/helpers';
import Autocomplete from '../common/Inputs/Autocomplete';

const DEFAULT_MIN_CHARS = 2;
const DEFAULT_PLACEHOLDER = 'Start typing to search codes...';

export const NaicsCodeAutocomplete = (props) => {
  const {
    onChange,
    value,
    multi,
    labelKey = 'value',
    label,
    minChars = DEFAULT_MIN_CHARS,
    placeholder = DEFAULT_PLACEHOLDER,
    ...rest
  } = props;

  const { options, loading, handleValueChange, filterOptions, handleInputChange } = useApiAutocomplete({
    labelKey,
    onChange: React.useCallback((val) => onChange && onChange(val), [onChange]),
    getOptionList: (params) => application.call(CODE_CATEGORIES.GET_LIST_NAICS_AUTOCOMPLETE, params),
    minChars,
  });

  const validateValueArray = () => {
    if (!multi) return value;
    if (Array.isArray(value)) {
      return value;
    } else {
      return [];
    }
  };

  return (
    <Autocomplete
      name="naics-code"
      options={options}
      label={label}
      labelKey={labelKey}
      loading={loading}
      value={validateValueArray()}
      filterOptions={filterOptions}
      onChange={handleValueChange}
      multiple={multi}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      freeSolo
      formatLabelCB={formatToTitleCase}
      onInputChange={handleInputChange}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      getOptionSelected={(option, value) => option?.id === value?.id}
      placeholder={placeholder}
      {...rest}
    />
  );
};

NaicsCodeAutocomplete.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  multi: PropTypes.bool,
  labelKey: PropTypes.string,
  label: PropTypes.string,
  minChars: PropTypes.number,
  placeholder: PropTypes.string,
};
